import React from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
import PropTypes from 'prop-types';

const ReportMarkReadAndDownload = ((props) => {
  const { i18n: { messages }, downloadCount, markAsReadCount, downloadLoadingFlag, auth: { documentDownloadDisabled, documentReadDisabled } } = props;
  return (
    <div className="markAsReadButton">
      {markAsReadCount !== 0 &&
        <Button
          tertiary
          disabled={documentReadDisabled} /* WMCE-3068 document mark as read disabled for RM Login on Behalf */
          testID="btn_markReadBtn_reportMarkReadDownload_test"
          size='large'
          onClick={() => props.handleMarkasReadOnclick()}
        >
          {messages['app.chedelivery.reports.markasread'] + ` (` + markAsReadCount + `)`}
        </Button>}
      {downloadCount !== 0 && <Button
        size='large'
        testID="btn_downloadBtn_reportMarkReadDownload_test"
        // make muster call for mark as read options
        disabled={documentDownloadDisabled} /* WMCE-3068 document download disability added for RM access */
        tertiary={documentDownloadDisabled}
        // loading={!!downloadLoadingFlag}
        onClick={() => downloadLoadingFlag ? ' ' : props.handlePreviewnDownloadClick()}
      >
        {messages['app.chedelivery.reports.download'] + ` (` + downloadCount + `)`}
      </Button>}
    </div>
  );
});

ReportMarkReadAndDownload.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  count: PropTypes.bool
};

ReportMarkReadAndDownload.defaultProps = {
  i18n: {},
  count: 0
};

export default createContainer(
  {
    $queries: {
      edelivery: {
        getUserPreferences: { $call: 'getUserPreferences' },
        showPrompt: true,
      },
      changePage: { $call: 'ui.history.push' },
      i18n: {
        messages: true,
      },
      auth: {
        documentDownloadDisabled: true,
        documentReadDisabled: true,
      }
    }
  })(ReportMarkReadAndDownload);
